 export const DATE_TODAY = '{TODAY}'
 export const DATE_START_END_TODAY = '{TODAY_START_END}'
 export const DATE_LAST_START_END = '{LAST_DAY_START_END}'
 export const DATE_MONTH_START = '{MONTH_START}'
 export const DATE_MONTH_START_END = '{MONTH_START_END}'
 export const DATE_PREVIOUS_MONTH_START_END = '{PREVIOUS_MONTH_START_END}'
 export const DATE_MONTH_PREVIOUS_START = '{MONTH_PREVIOUS_START}'
 export const DATE_MONTH_PREVIOUS_END = '{MONTH_PREVIOUS_END}'
 export const DATE_WEEK_START = '{WEEK_START}'
 export const DATE_WEEK_START_END = '{WEEK_START_END}'
 export const DATE_MONTH_END = '{MONTH_END}'
 export const DATE_WEEK_END = '{WEEK_END}'
 export const DATE_YEAR_DAY_START = '{YEAR_DAY_START}'
 export const DATE_YEAR_START_END = '{YEAR_DAY_START_END}'
 export const DATE_YEAR_DAY_END = '{YEAR_DAY_END}'
 export const DATE_QUARTER_DAY_START = '{QUARTER_DAY_START}'
 export const DATE_QUARTER_DAY_END = '{QUARTER_DAY_END}'
 export const DATE_QUARTER_DAY_START_END = '{QUARTER_DAY_START_END}'
 export const DATE_LAST_62_DAYS_START_END = '{LAST_62_DAYS_START_END}'

 export const DATE_PICKER_ACTIONS_LIST = [
     DATE_TODAY,
     DATE_MONTH_START,
     DATE_MONTH_PREVIOUS_START,
     DATE_MONTH_PREVIOUS_END,
     DATE_WEEK_START,
     DATE_MONTH_END,
     DATE_WEEK_END,
     DATE_YEAR_DAY_START,
     DATE_YEAR_DAY_END,
     DATE_QUARTER_DAY_START,
     DATE_QUARTER_DAY_END,
 ]

 export const DATE_PICKER_ACTIONS = [
    {label: 'todayDay', value: DATE_TODAY},
    {label: 'mothStart', value: DATE_MONTH_START},
    {label: 'weekStart', value: DATE_WEEK_START},
    {label: 'weekEnd', value: DATE_WEEK_END},
    {label: 'monthEnd', value: DATE_MONTH_END},
    {label: 'monthPreviousStart', value: DATE_MONTH_PREVIOUS_START},
    {label: 'monthPreviousEnd', value: DATE_MONTH_PREVIOUS_END},
    {label: 'yearDayStart', value: DATE_YEAR_DAY_START},
    {label: 'yearDayEnd', value: DATE_YEAR_DAY_END},
    {label: 'quarterDayStart', value: DATE_QUARTER_DAY_START},
    {label: 'quarterDayEnd', value: DATE_QUARTER_DAY_END},
]

 export const DATE_START_END_TEMPLATE_ITEMS = [
     {label: 'date.currentDay', value: DATE_START_END_TODAY},
     {label: 'date.lastDay', value: DATE_LAST_START_END},
     {label: 'date.currentWeek', value: DATE_WEEK_START_END},
     {label: 'date.currentMoth', value: DATE_MONTH_START_END},
     {label: 'date.previousMoth', value: DATE_PREVIOUS_MONTH_START_END},
     {label: 'date.last62Days', value: DATE_LAST_62_DAYS_START_END},
     {label: 'date.currentQuarter', value: DATE_QUARTER_DAY_START_END},
     {label: 'date.currentYear', value: DATE_YEAR_START_END},
 ]

 export const DATE_PICKER_DATE_START_END_ACTIONS = [
     {label: 'date.currentDay', value: DATE_START_END_TODAY},
     {label: 'date.lastDay', value: DATE_LAST_START_END},
     {label: 'date.currentWeek', value: DATE_WEEK_START_END},
     {label: 'date.previousMoth', value: DATE_PREVIOUS_MONTH_START_END},
     {label: 'date.currentMoth', value: DATE_MONTH_START_END},
     {label: 'date.currentQuarter', value: DATE_QUARTER_DAY_START_END},
     {label: 'date.currentYear', value: DATE_YEAR_START_END},
 ]